/// <reference types="@types/google.maps" />
export class BKSFilter {
  showAllFlights: boolean = false;
  showPlannedFlights: boolean = false;
  showFinishedEvents: boolean = false;
  showAllDrivers: boolean = false;
  showLandside: boolean = false;
  sound: boolean = false;
  zoom: number;
  mapCenter: google.maps.LatLng;
  //mapCenter: 1;
  darkMap: boolean = false;
}


export class RequestError {
  message: string;
}
